import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'src/environments/environment';
import { Company } from '../model/Company.model';
import { AjaxService } from './ajax.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private apiUrl = `${API}/companies`;

  constructor(private ajax: AjaxService) { }

  getCompanies(): Observable<Company[]> {
    return this.ajax.get(this.apiUrl);
  }
} 